//login
import { login, forgotPassword, loginResponse, loginClear, refreshToken } from "./action/Login"
import { authCheck, loginCheckResponse } from './action/Login/loginCheck'
// profile 
import { getUpdateProfile } from "./action/Login/profilegetApi"
// card api (dashboard)
import { getAddCardDetail } from "./action/cardapi"
// client 
import { getClientApi } from "./action/Clientgetapi"
// notification
import { getNotificationsAll } from "./action/Notigetapi"

// transaction 
import {getTransactionApi} from "./action/Transactiongetapi"
export const actionsApi = {
    login, 
    forgotPassword,
    loginResponse, 
    loginClear, 
    refreshToken,
    authCheck, 
    loginCheckResponse,
    // profile 
    getUpdateProfile,
    // cards
    getAddCardDetail,
    // client
    getClientApi,
    // notification
    getNotificationsAll,
    // transaction 
    getTransactionApi
}
